import { autoinject, bindable, computedFrom } from "aurelia-framework";
import { type  RightShipInspectionDetailsModel } from "../../../models/rightship-inspections.models";
import { ActionButtonItem } from "../../../models/common.models";

@autoinject
export class PartialInspectionLayout {
    
    @bindable
    public title: string;

    @bindable
    public inspectionModel: RightShipInspectionDetailsModel;

    @bindable
    public showContentDetail: boolean = true;

    @bindable
    public showContent: boolean = true;

    @bindable
    public actions: ActionButtonItem[] = [];

    constructor() {}

    @computedFrom("inspectionModel")
    get vesselDetailsFields() {
        const fields = this.inspectionModel && this.inspectionModel.vesselDetails ? [
            {
                label: "Vessel",
                value: this.inspectionModel.vesselDetails.vesselName
            },
            {
                label: "IMO",
                value: this.inspectionModel.vesselDetails.vesselImo
            },
            {
                label: "Date of build",
                value: this.inspectionModel.vesselDetails.dateOfBuild
            },
            {
                label: "Vessel type",
                value: this.inspectionModel.vesselDetails.vesselType
            },
            {
                label: "DWT",
                value: this.inspectionModel.vesselDetails.dwt
            },
            {
                label: "Flag",
                value: this.inspectionModel.vesselDetails.flag
            }
        ]: [];
        return fields;
    }

    @computedFrom("inspectionModel")
    get portAndOperationalDetailsFields() {
        const fields = this.inspectionModel && this.inspectionModel.portAndOperationalDetails ? [
            {
                label: "Requested inspection date",
                value: this.inspectionModel.portAndOperationalDetails.requestedInspectionDate
            },
            {
                label: "Port",
                value: this.inspectionModel.portAndOperationalDetails.port
            },
            {
                label: "Country",
                value: this.inspectionModel.portAndOperationalDetails.country
            },
            {
                label: "Est. arrival date",
                value: this.inspectionModel.portAndOperationalDetails.estimatedArrivalDate
            },
            {
                label: "Length of time at berth",
                value: this.inspectionModel.portAndOperationalDetails.lengthOfTimeAtBerth
            },
            {
                label: "Cargo operation",
                value: this.inspectionModel.portAndOperationalDetails.cargoOperation
            }
        ]: [];
        return fields;
    }

    @computedFrom("inspectionModel")
    get agentDetailsFields() {
        const fields = this.inspectionModel && this.inspectionModel.agentDetails ? [
            {
                label: "Agent name",
                value: this.inspectionModel.agentDetails.agentName
            },
            {
                label: "Agent office number",
                value: this.inspectionModel.agentDetails.agentOfficeNumber
            },
            {
                label: "Agent email address",
                value: this.inspectionModel.agentDetails.agentEmailAddress
            }
        ]: [];
        return fields;
    }

    @computedFrom("inspectionModel")
    get vesselName(): string {
        if(!this.inspectionModel || !this.inspectionModel.vesselDetails) return "";
        const vesselName = this.inspectionModel.vesselDetails.vesselName || "";
        return vesselName;
    }

    @computedFrom("inspectionModel")
    get vesselImo(): string {
        if(!this.inspectionModel || !this.inspectionModel.vesselDetails) return "";
        let vesselImo = this.inspectionModel.vesselDetails.vesselImo || "";
        if(vesselImo) vesselImo = `IMO ${vesselImo}`;
        return vesselImo;
    }

    @computedFrom("inspectionModel")
    get inspectionNumber(): string {
        if(!this.inspectionModel) return "";
        const inspectionNumber = this.inspectionModel.rightShipInspectionId || "";
        return `INSP #${inspectionNumber}`;
    }

    @computedFrom("inspectionModel")
    get location(): string {
        if(!this.inspectionModel || !this.inspectionModel.portAndOperationalDetails) return "";
        const port = this.inspectionModel.portAndOperationalDetails.port || "";
        const country = this.inspectionModel.portAndOperationalDetails.country || "";
        return `${country}, ${port}`;
    }

    @computedFrom("inspectionModel")
    get requestedInspectionDate(): string {
        if(!this.inspectionModel || !this.inspectionModel.portAndOperationalDetails) return "";
        const requestedInspectionDate = this.inspectionModel.portAndOperationalDetails.requestedInspectionDate || "";
        return requestedInspectionDate;
    }

    public getTooltipViewModel() {
        const name = "views/partials/partial-inspection-layout/partial-tooltip-inspection-details/partial-tooltip-inspection-details";
        require( name +'.ts');
        require( name +'.html');
        return {
            name,
            model: {
                inspectionModel: this.inspectionModel
            }
        };
    }
}